import { css } from "@emotion/css"

import GlobalSign from "../../../../lib/GlobalSign"
import ISO9001 from "./ISO9001/ISO9001"
import JPCA from "./JPCA/JPCA"

const CertificationMarks = () => {
  return (
    <ul className={style}>
      <li>
        <GlobalSign />
      </li>
      <li>
        <JPCA />
      </li>
      <li>
        <ISO9001 />
      </li>
    </ul>
  )
}

export default CertificationMarks

const style = css`
  display: flex;
  height: 90px;
  padding-right: 12px;
  list-style: none;
  background-color: #fff;
  border-radius: 5px;
  > li {
    padding-left: 12px;
    &:first-child {
      padding-top: 13px;
    }
  }
`
